import React from 'react';
import Hero from './components/Hero';
import { AppContainer } from './App.styles';

const App = () => {
  return (
    <AppContainer>
      <Hero />
    </AppContainer>
  );
};

export default App;